import { render, staticRenderFns } from "./ServiceNameWithEditing.vue?vue&type=template&id=203a1272&scoped=true&"
import script from "./ServiceNameWithEditing.vue?vue&type=script&lang=js&"
export * from "./ServiceNameWithEditing.vue?vue&type=script&lang=js&"
import style0 from "./ServiceNameWithEditing.vue?vue&type=style&index=0&id=203a1272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a1272",
  null
  
)

export default component.exports